import { whatsappUrl, buildWhatsappMessage, sendOrderIntent } from "../../lib/api";

export const OrderLink = ({ extract, version, sponsor, lieu, orderRef, extra = {}, offerToken = null, onTrack, testid, className, children, disabled = false }) => (
  <a
    href={whatsappUrl(extract.whatsapp_number, buildWhatsappMessage(extract, sponsor?.name, version.name ? version : null, { ...extra, ref: orderRef }))}
    target="_blank"
    rel="noreferrer"
    aria-disabled={disabled || undefined}
    tabIndex={disabled ? -1 : undefined}
    onClick={(e) => { if (disabled) { e.preventDefault(); return; } onTrack("whatsapp"); sendOrderIntent({ ref: orderRef, slug: extract.slug, version: version.key, city: extra.city || null, pickup: extra.pickup || null, lieu: lieu || null, offer_token: offerToken }); }}
    data-testid={testid}
    className={className}
  >
    {children}
  </a>
);
